var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle, _path11, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoColouredTronrudHl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "86.089mm",
    height: "20.198mm",
    viewBox: "0 0 86.089 20.198",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 289.01,
    cy: 210.23,
    r: 30.846,
    fill: "none",
    stroke: "#000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 289.01,
    cy: 210.9,
    r: 30.846,
    display: "none",
    fill: "none",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "powerclip",
    d: "m25.931 205.23h335.38v55.6h-335.38zm293.93 5.672a30.846 30.846 0 0 0-30.846-30.846 30.846 30.846 0 0 0-30.846 30.846 30.846 30.846 0 0 0 30.846 30.846 30.846 30.846 0 0 0 30.846-30.846z",
    fill: "none",
    stroke: "#000"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19.2 -58.143)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.26458 0 0 .26458 8.8996 9.7717)",
    display: "none",
    fill: "#000000",
    fontFamily: "Iceland",
    fontSize: "96px",
    letterSpacing: "9px",
    style: {
      lineHeight: 1.15,
      shapeInside: "url(#rect2753)",
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 11.016 10.652)",
    clipPath: "url(#a)",
    fill: "#111827",
    style: {
      shapeInside: "url(#rect2753-73)",
      whiteSpace: "pre"
    },
    "aria-label": "HOLDT"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m30.931 255.16v-39.744q0-2.88 1.152-3.648 1.248-0.768 4.128-0.768h10.464v17.184h21.696v-17.184h15.744v39.168q0 2.976-0.96 4.032-0.96 0.96-4.416 0.96h-10.368v-18.816h-21.696v18.816z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m130.08 255.83q-7.68 0-13.056-1.056t-8.832-3.552q-3.36-2.592-4.992-7.008-1.536-4.416-1.536-11.136 0-6.912 1.632-11.232 1.632-4.416 5.088-6.912 3.552-2.592 8.928-3.648 5.472-1.056 13.056-1.056t12.96 1.056 8.736 3.648q3.456 2.496 4.992 6.912 1.632 4.416 1.632 11.232t-1.632 11.232-5.088 7.008q-3.456 2.496-8.928 3.552-5.376 0.96-12.96 0.96zm0.096-8.16q3.168 0 5.472-0.576 2.4-0.672 3.84-2.304 1.536-1.632 2.208-4.416 0.768-2.88 0.768-7.296 0-4.512-0.768-7.296-0.672-2.88-2.208-4.416-1.44-1.632-3.84-2.208-2.304-0.672-5.472-0.672-3.264 0-5.664 0.672-2.304 0.576-3.744 2.208-1.44 1.536-2.208 4.416-0.768 2.784-0.768 7.296 0 4.416 0.768 7.296 0.768 2.784 2.208 4.416t3.744 2.304q2.4 0.576 5.664 0.576z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m191.97 211v35.904h28.32v8.256h-44.064v-38.976q0-1.728 0.192-2.88 0.288-1.152 1.344-1.728t3.648-0.576z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m290.16 233.27q0 7.008-1.632 11.424-1.536 4.32-4.896 6.624-3.264 2.304-8.352 3.168-5.088 0.768-12.192 0.768-4.32 0-8.256 0t-7.392-0.096q-3.456 0-6.528 0-2.976 0-5.568 0v-37.824q0-3.36 1.344-4.8t4.992-1.536q2.496 0 5.376 0 2.976-0.096 5.952-0.096 3.072 0 6.048 0 3.072 0 5.664 0 6.816 0.096 11.616 1.056 4.8 0.864 7.872 3.264 3.072 2.304 4.512 6.72 1.44 4.32 1.44 11.328zm-39.072 13.92q0.96 0 2.208 0 1.344 0 2.784 0.096 1.536 0 2.976 0t2.496 0q3.36 0 5.76-0.576t3.84-2.112 2.112-4.32 0.672-7.008q0-6.048-1.248-9.12-1.152-3.072-3.936-4.128-2.688-1.152-7.584-1.152-1.152 0-2.976 0-1.728 0-3.456 0.096-1.728 0-2.976 0.096-0.288 0.48-0.48 1.152t-0.192 1.92z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m303.31 211h52.992v8.352h-18.528v30.624q0 3.072-0.96 4.128t-4.32 1.056h-10.56v-35.808h-18.624z"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 87.484,
    cy: 66.454,
    r: 8.1612,
    fillOpacity: 0.40392,
    opacity: 0.6,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 11.016 10.83)",
    clipPath: "url(#b)",
    fill: "#ee3224",
    strokeWidth: 1.0016,
    style: {
      shapeInside: "url(#rect2753-7)",
      whiteSpace: "pre"
    },
    "aria-label": "HOLDT"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m30.931 255.16v-39.744q0-2.88 1.152-3.648 1.248-0.768 4.128-0.768h10.464v17.184h21.696v-17.184h15.744v39.168q0 2.976-0.96 4.032-0.96 0.96-4.416 0.96h-10.368v-18.816h-21.696v18.816z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m130.08 255.83q-7.68 0-13.056-1.056t-8.832-3.552q-3.36-2.592-4.992-7.008-1.536-4.416-1.536-11.136 0-6.912 1.632-11.232 1.632-4.416 5.088-6.912 3.552-2.592 8.928-3.648 5.472-1.056 13.056-1.056t12.96 1.056 8.736 3.648q3.456 2.496 4.992 6.912 1.632 4.416 1.632 11.232t-1.632 11.232-5.088 7.008q-3.456 2.496-8.928 3.552-5.376 0.96-12.96 0.96zm0.096-8.16q3.168 0 5.472-0.576 2.4-0.672 3.84-2.304 1.536-1.632 2.208-4.416 0.768-2.88 0.768-7.296 0-4.512-0.768-7.296-0.672-2.88-2.208-4.416-1.44-1.632-3.84-2.208-2.304-0.672-5.472-0.672-3.264 0-5.664 0.672-2.304 0.576-3.744 2.208-1.44 1.536-2.208 4.416-0.768 2.784-0.768 7.296 0 4.416 0.768 7.296 0.768 2.784 2.208 4.416t3.744 2.304q2.4 0.576 5.664 0.576z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m191.97 211v35.904h28.32v8.256h-44.064v-38.976q0-1.728 0.192-2.88 0.288-1.152 1.344-1.728t3.648-0.576z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m235.49 201.83c-2.7954 0-5.5913 0.0446-8.3867 0.13477h-7.5742c-3.4266 0.0902-5.7708 0.81145-7.0332 2.1641-1.2624 1.3526-1.8945 3.6076-1.8945 6.7637v53.293h17.043c3.2462 0.0902 6.7189 0.13477 10.416 0.13477h11.633c6.6728 0 12.399-0.36065 17.178-1.082 4.7792-0.81156 8.7017-2.2987 11.768-4.4629 3.1561-2.1642 5.4557-5.2762 6.8984-9.334 1.533-4.148 2.2988-9.513 2.2988-16.096 0-6.5827-0.67669-11.903-2.0293-15.961-1.3526-4.148-3.4719-7.3026-6.3574-9.4668-2.8856-2.2543-6.5812-3.788-11.09-4.5996-4.5087-0.90174-9.9649-1.3981-16.367-1.4883h-7.9805zm7.3047 11.227h4.1914c4.5989 0 8.1626 0.54097 10.688 1.623 2.615 0.99191 4.4628 2.9308 5.5449 5.8164 1.1723 2.8856 1.7578 7.1687 1.7578 12.85 0 3.9676-0.31606 7.26-0.94727 9.875-0.63122 2.615-1.622 4.6432-2.9746 6.0859-1.3526 1.4428-3.1558 2.4355-5.4102 2.9766s-4.9611 0.81054-8.1172 0.81054h-7.709c-1.3526-0.0902-2.6594-0.13476-3.9219-0.13476h-3.1113v-35.303c0-1.1723 0.0892-2.0739 0.26953-2.7051 0.18035-0.63122 0.40722-1.1722 0.67774-1.623 1.1722-0.0902 2.5702-0.13672 4.1934-0.13672 1.6231-0.0902 3.246-0.13477 4.8692-0.13477zm32.299 0.24219 4.1211 1.666c0.62353 0.96776-1.3047 2.9394-1.3047 2.9394l2.9297 1.1602s-1.2537 1.5084-2.1777 1.1289c1.6841 2.4928-4.4004-0.90234-4.4004-0.90234-0.4071-0.836 1.0723-2.209 1.0723-2.209s-2.0051 1.0636-2.1152-0.35547l1.9688-1.8613s-1.6868 0.16375-1.0879-1.1504z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m306.38 201.97h74.664v11.768h-26.105v43.148q0 4.3283-1.3526 5.8162-1.3526 1.4879-6.0867 1.4879h-14.879v-50.452h-26.241z"
  }))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.24577 0 0 .26458 .52496 -25.611)",
    display: "none",
    fill: "#000000",
    fontFamily: "Iceland",
    fontSize: "24px",
    style: {
      lineHeight: 1.25,
      shapeInside: "url(#rect418)",
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.24577 0 0 .26458 .52496 -25.611)",
    display: "none",
    fill: "#ffffff",
    fontFamily: "Iceland",
    fontSize: "24px",
    style: {
      lineHeight: 1.25,
      shapeInside: "url(#rect418-2)",
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85.367,
    cy: 65.395,
    r: 8.1612,
    display: "none",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m83.802 67.266 1.0903 0.44074c0.16498 0.25606-0.34491 0.77775-0.34491 0.77775l0.7753 0.30682s-0.33201 0.39938-0.57648 0.29897c0.4456 0.65955-1.1643-0.23862-1.1643-0.23862-0.10771-0.22119 0.28358-0.58475 0.28358-0.58475s-0.53048 0.28154-0.55962-0.09393l0.52092-0.49231s-0.44606 0.04317-0.28758-0.30453z",
    display: "none",
    fill: "#e09e00"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.484,
    cy: 66.454,
    r: 8.1612,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColouredTronrudHl);
export default __webpack_public_path__ + "static/media/logo_coloured_tronrud_hl.ee1632a7d6582e17028ab77f63500aee.svg";
export { ForwardRef as ReactComponent };